/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

export const SELECT_TYPE_NUMERIC = `numeric`;
export const SELECT_TYPE_STRING = `string`;

/**
 * Select data types.
 */
export type SelectDataTypes = typeof SELECT_TYPE_NUMERIC | typeof SELECT_TYPE_STRING;

/**
 * The props for `<SelectSegmentRule />`.
 * @export
 * @interface SelectSegmentRuleProps
 */
export interface SelectSegmentRuleProps {
  /**
   * Change callback.
   * @type {(ref: React.RefObject<HTMLInputElement>, value: string): void}
   * @memberof SelectSegmentRuleProps
   */
  onChange?(ref: React.RefObject<HTMLInputElement>, value: string): void;

  /**
   * The pre-selected rule.
   * @type {string}
   * @memberof SelectSegmentRuleProps
   */
  preselectedRule?: string;

  /**
   * ID of the rule.
   * @type {string}
   * @memberof SelectSegmentRuleProps
   */
  ruleId: string;

  /**
   * Optionally set the preferred data type.
   * @type {SelectDataTypes}
   * @memberof SelectSegmentRuleProps
   */
  dataType?: SelectDataTypes;

  /**
   * Any form errors.
   * @type {MouseEventHandler<HTMLButtonElement>}
   * @memberof SelectSegmentRuleProps
   */
  errors?: Record<string, string | null>;
}

/**
 * Rule operator.
 * @export
 * @type RuleTypeProps
 */
export type RuleTypeProps = string;
